"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.button_blank = void 0;
var static_values_1 = require("../../../src/core/static-values");
function button_blank(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, hasReturnVal = utils.hasReturnVal, use = utils.use, cySelectSegment = utils.cySelectSegment, cyInput = utils.cyInput, IDs = utils.IDs;
    var _a = static_values_1.staticValues.buttonBlank, cpuValue = _a.cpuValue, inputValue = _a.inputValue, labelValue = _a.labelValue;
    var clickBtn3 = function () { return cy.get("#".concat(IDs.buttonIDs.blankID)).click().wait(10).then(cyInput); };
    describe("Button Blank - ".concat(labelValue), function () {
        it('arrow key functions', function () {
            loadPrimaryInput()
                .then(clickBtn3)
                .should('have.value', inputValue)
                .then(hasReturnVal(cpuValue))
                .then(function () {
                return cySelectSegment('hrs12')
                    .then(use.upArrow)
                    .should('have.value', '01:-- --')
                    .then(use.downArrow)
                    .should('have.value', '12:-- --')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '12:00 --')
                    .then(use.downArrow)
                    .should('have.value', '12:59 --')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '12:59 AM')
                    .then(use.downArrow)
                    .should('have.value', '12:59 PM')
                    .then(use.del)
                    .should('have.value', '12:59 --')
                    .then(use.leftArrow)
                    .then(use.backspace)
                    .should('have.value', '12:-- --')
                    .then(use.leftArrow)
                    .then(use.del)
                    .should('have.value', '--:-- --');
            });
        });
        it('can press button twice', function () {
            loadPrimaryInput()
                .then(clickBtn3)
                .should('have.value', '--:-- --')
                .then(hasReturnVal(''))
                .then(function () {
                return cySelectSegment('hrs12')
                    .then(use.upArrow)
                    .should('have.value', '01:-- --')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '01:00 --')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '01:00 AM')
                    .then(clickBtn3)
                    .should('have.value', '--:-- --');
            });
        });
    });
}
exports.button_blank = button_blank;
